import { render, staticRenderFns } from "./EtapaProdutos.vue?vue&type=template&id=0adf3c1c&scoped=true"
import script from "./EtapaProdutos.vue?vue&type=script&lang=js"
export * from "./EtapaProdutos.vue?vue&type=script&lang=js"
import style0 from "./EtapaProdutos.vue?vue&type=style&index=0&id=0adf3c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf3c1c",
  null
  
)

export default component.exports